import script from "./Page13.vue?vue&type=script&setup=true&lang=js"
export * from "./Page13.vue?vue&type=script&setup=true&lang=js"

import "./Page13.vue?vue&type=style&index=0&id=5e52f72c&lang=less"

const __exports__ = script;

export default __exports__